<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper log-wrap" >

    <div class="row">

        <!-- Login Banner -->
        <div class="col-md-7 login-bg" :style="{'background-color':this.$store.state.RenkTonlari[0]?.color??'#fff'}">
                <div class="welcome-login" style="margin-left: auto; margin-right: auto;">
                    <div class="login-banner">
                        <img src="https://storage.googleapis.com/schoollms/img/login-img.png" class="img-fluid" alt="Logo">
                    </div>
                    <div class="mentor-course text-center" >
                        <h2 :style="{'color':ZeminRengiIcinYazi(this.$store.state.RenkTonlari[4]?.color??'#fff')}">
                            Welcome to 
                            <br>
                            {{this.$store.state.DomainAdi}}
                        </h2>
                    </div>
                </div>
        </div>
        <!-- /Login Banner -->

        <div class="col-md-5 login-wrap-bg">

            <!-- Login -->
            <div class="login-wrapper"  style="background-color: #fff;" :style="{'justify-content': getOkulAyarlar.GoogleLogIn == 1 ? 'space-around':'' }">
                <div class="loginbox">
                    <div class="w-100" >
                        <div class="img-logo" v-if="getOkulAyarlar.GoogleLogIn == 0">
                            <img :src="`https://storage.googleapis.com/schoollms/img/schoollogo/${this.$store.state.DomainAdi}.png`" class="img-fluid" alt="Logo"  >
                        </div>
                        <div v-if="getOkulAyarlar.GoogleLogIn == 1">
                            <div class="img-logo" style="justify-content: center;">
                                <img :src="`https://storage.googleapis.com/schoollms/img/schoollogo/${this.$store.state.DomainAdi}.png`" class="img-fluid" alt="Logo" style="width: 190px !important;"  >
                                <img src="https://storage.googleapis.com/schoollms/img/google.png" class="img-fluid" alt="Logo">
                            </div>

                            <div class="d-grid">
                                <button class="btn btn-primary btn-start THMbutton" 
                                :style="Button1StyleObject" type="submit" @click="$emit('submit')">Sign In with Google</button>
                            </div>
                        </div>
                        <div v-else >
                            <div class="input-block">
                                <label class="form-control-label">Username</label>
                                <input :value="KullaniciAdi" @input="$emit('update:KullaniciAdi', $event.target.value)" type="text" class="form-control THMinput" placeholder="Enter your user name" 
                                :style="InputStyleObject" >
                            </div>
                            <div class="input-block">
                                <label class="form-control-label">Password</label>
                                <div class="pass-group">
                                    <input :value="Sifre" @input="$emit('update:Sifre', $event.target.value)" :type="SifreTipi" class="form-control pass-input THMinput" :style="InputStyleObject"
                                        placeholder="Enter your password">
                                    <span v-on:click="$emit('toggle-password')" class="toggle-password " :class="SifreIcon"></span>
                                </div>
                            </div>
 
                            <div class="d-grid">
                                <button class="btn btn-primary btn-start THMbutton" 
                                v-on:click="$emit('submit')" :style="Button1StyleObject" type="submit" >Log In</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Login -->

        </div>

    </div>

    </div>
    <!-- /Main Wrapper -->
</template>

<script>
import {mapGetters} from "vuex";
import { getTextColorBasedOnBackground } from "@/global/color";

export default {
    name: "LoginFormDefault",
    props: {
        KullaniciAdi: { type: String, default: '' },
        Sifre: { type: String, default: '' },
        SifreTipi: { type: String, default: 'password' },
        SifreIcon: { type: String, default: 'feather-eye' },
    },
    computed:{
        ...mapGetters(['getOkulAyarlar','Button1StyleObject','InputStyleObject']),
    },
    methods: {
        ZeminRengiIcinYazi(Renk) {
            return getTextColorBasedOnBackground(Renk);
        },
    },
}
</script>

<style scoped>
</style>
